<template>
  <el-card shadow="never" class="statistics-card">
    <div class="title" style="font-size: 24px; font-weight: bold">库存数据概览</div>
    <el-row :gutter="0" style="margin-top: 16px">
      <el-col :span="6">
        <div>{{ titles.total }}</div>
        <div class="body">
          <span class="num">{{ statics.stockNum || 0 }}</span>
          <span class="unit">条</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div>{{ titles.done }}</div>
        <div class="body">
          <span class="num">{{ statics.expiryNum || 0 }}</span>
          <span class="unit">条</span>
        </div>
      </el-col>
      <el-col :span="6">
        <div>{{ titles.todo }}</div>
        <div class="body">
          <span class="num">{{ statics.expiredNum || 0 }}</span>
          <span class="unit">条</span>
        </div>
      </el-col>
      <el-col :span="6" v-if="tabs !== 'yesterday'">
        <div>{{ titles.progress }}</div>
        <div class="body">
          <span class="num">{{ statics.thirtyExpiredNum || 0 }}</span>
          <span class="unit">条</span>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import fetch from '@/api';

export default {
  name: 'staticsCard',
  props: {
    type: {
      type: String,
      // e.g. fourClass special prescription
      default: 'fourClass'
    }
  },
  data() {
    return { tabs: 'today', statics: {} };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    },
    titles() {
      const { type } = this;

      const titleMap = {
        total: '库存数量',
        done: '近效期',
        todo: '过期',
        progress: '近30天即将过期'
      };

      return titleMap;
    }
  },
  mounted() {
    this.fetchStaticsData();
  },
  methods: {
    handleChangeType() {
      this.fetchStaticsData();
    },
    fetchStaticsData() {
      const { storeId } = this;
      fetch.pc_inventory_supervision_stock_summary({ storeId }).then(res => {
        this.statics = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
